<span *ngIf="!src">
  <h2 class="panel-title">{{ title }}</h2>
  <h3 class="panel-description">{{ description }}</h3>
</span>
<span *ngIf="src">
  <img [src]="src" class="panel-image" />
</span>
